import { toast } from "react-toastify";
import i18n from "../../i18n";

interface NotificationProps {
  msg: any;
}

const notificationToUser = (props: NotificationProps) => {
  const { msg } = props;
   if (typeof msg === "string") {
    const normalizedMsg = msg.trim();
    const translatedMsg = i18n.exists(normalizedMsg)
      ? String(i18n.t(normalizedMsg))
      : normalizedMsg;
    toast(translatedMsg);
  }
};

export default notificationToUser;
